// import { Button } from "@/core/components/ui/button";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { getCustomerNameOrPhone } from "@/customer/utils";
import InfoPair from "./info-pair";
import { NameAndDate, NameAndDateSkeleton } from "./name-and-date";
import type { ReferralContentProps } from "./referralContent";

export const InProgressReferralCardSkeleton = () => (
  <Stack className="p-4">
    <NameAndDateSkeleton />
    <Stack gap="sm">
      <Skeleton className="h-4 w-32" /> {/* Services */}
      <Skeleton className="h-4 w-48" /> {/* Referred by */}
    </Stack>
  </Stack>
);

export const InProgressReferralCardContent = ({
  referral,
  onLost,
  onMoveToPaid,
  onDelete,
}: ReferralContentProps) => (
  <Stack className="p-4">
    <NameAndDate
      referral={referral}
      hideDate
      onLost={onLost}
      onMoveToPaid={onMoveToPaid}
      onDelete={onDelete}
    />
    <Stack gap="sm">
      <InfoPair
        label="Services"
        info={referral.service_needed || "No services"}
      />
      <InfoPair
        label="Referred by"
        info={getCustomerNameOrPhone(referral.advocate)}
      />
    </Stack>
  </Stack>
);
